// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  organizationId: __t.string(),
  name: __t.string(),
  workflowName: __t.string(),
  description: __t.option(__t.string()),
  icon: __t.option(__t.string()),
  category: __t.option(__t.string()),
  nodes: __t.string(),
  connections: __t.string(),
  pinData: __t.option(__t.string()),
  author: __t.string(),
  executionType: __t.string(),
  version: __t.string(),
  isActive: __t.bool(),
  isVisible: __t.bool(),
  isOnHomeView: __t.bool(),
  requiresAccount: __t.bool(),
  tagIds: __t.array(__t.string()),
};
